import { render } from "./bet-group.vue?vue&type=template&id=5117c89d&scoped=true&ts=true"
import script from "./bet-group.vue?vue&type=script&lang=ts"
export * from "./bet-group.vue?vue&type=script&lang=ts"

import "./bet-group.vue?vue&type=style&index=0&id=5117c89d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5117c89d"]])

export default __exports__